<template lang="html">
    <div>
        <el-container style="min-height:1200px">
            <el-aside style="overflow:inherit;background: #25304c;" width="202px">
                <div v-bind:style="{width:'201px',height:height,backgroundColor:'#25304c'}">
                    <div style="text-align:center;padding-top:20px;padding-bottom:20px;">
                        <!--            <img src="../../../public/static/minLogo.png" alt="User Image" style="width:70px;height:auto;"/>-->
                        <div style="color:#fff;margin-top:10px;">
                            <el-tooltip class="item" placement="bottom">
                                <div slot="content">当前用户：{{loginInfo.channelPageName}}<br/>登录时间：{{loginInfo.loginTime
                                    | dateTimeFormat}}<br/></div>
                                <div style="cursor:pointer;color:white;">
                                    <div style="color:#fff;">
                                        <span>{{loginInfo.channelPageName}}</span>

                                    </div>
                                    <div>
                                        <el-button type="text"  @click="dialogVisible=true">修改密码</el-button>
                                        <el-button @click="loginOut()" type="text">退出</el-button>
                                    </div>
                                </div>
                            </el-tooltip>

                        </div>
                    </div>
                    <menus :menuGroup="menuGroup"></menus>
                </div>
            </el-aside>
            <el-container>
                <el-main>
                    <!-- <el-alert
                      :title="msg"
                      type="error" :closable="false">
                    </el-alert> -->
                    <div style="padding: 12px;background: #eee;margin-top:10px;margin-bottom:10px;border-radius:3px;"
                         v-show="showMsg ===false">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: router.path }" v-bind:key="index" v-for="(router,index) in routers">{{router.name}}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <el-card class="box-card" style="margin-top:10px;">
                        <keep-alive
                                include="customGroupList,usedCarValuation,clue-tab-index,clueIntranetManagement,plus-intranet-business-tab-index,actionRecordManagement,withdraw-cash,question-user-management,business-management,car-exhibition-detail,合伙人奖励-tab-index,channel-management,thematic-management">
                            <router-view style="margin-top:10px;"></router-view>
                        </keep-alive>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>

        <el-dialog :visible.sync="showUserInfo" title="登录信息">
            <img alt=""
                 height="60px" src="http://csz-public.oss-cn-hangzhou.aliyuncs.com/default_head.png" style="float:left;border-radius: 30px;" width="60px">&nbsp;&nbsp;
            <div style="float:left;margin-left:20px;margin-top:5px;">
                <span style="font-size: 16px;">{{loginInfo.channelPageName}}-{{loginInfo.roleName}}</span><br/>
                <span style="font-size: 16px;">登录时间：{{loginInfo.loginTime | dateTimeFormat}}</span>
            </div>
            <span class="dialog-footer" slot="footer">
        <el-button @click="dialogVisible = true" v-if="loginInfo.loginPath!='cxh'">修改密码</el-button>
        <el-button @click="loginOut()" type="primary">安全退出</el-button>
      </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible" title="修改密码">
            <el-form :model="updatePasswordFrom" label-width="120px" ref="updatePasswordFrom">
                <el-form-item :rules="[{ required: true, message: '密码不能为空'}]" label="新密码" prop="password">
                    <el-input placeholder="请输入新密码" type="input" v-model="updatePasswordFrom.password"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button @click="updatePassword(updatePasswordFrom.password)" type="primary">确认修改</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import Menus from './children/Menus'
import BasicPager from '@/mixins/BasicPager'
import sysModel from '@/framework/models/sysModel'
import channelModel from '@/framework/models/channelModel'

export default {
  name: 'Home',
  extends: BasicPager,
  data: function () {
    return {
      height: '0px',
      closable: true,
      activeName: null,
      routerName: null,
      menuGroup: 2,
      showUserInfo: false,
      showMsg: false,
      msg: '',
      tabs: [],
      routers: [],
      xPathDialogVisible: false,
      dialogVisible: false,
      updatePasswordFrom: {
        password: ''
      }
    }
  },
  watch: {
    tabs: function (tabs) {
      if (tabs.length === 1) {
        this.closable = false
      } else {
        this.closable = true
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      let router = {
        name: to.name,
        path: to.path
      }

      vm.selectTab(to)

      if (localStorage.routers) {
        let routers = JSON.parse(localStorage.routers)
        vm.routers = routers
      } else {
        let routers = [router]
        localStorage.routers = JSON.stringify(routers)
      }

      let showMsg = to.meta.hasFirstPage
      vm.showMsg = showMsg == null ? false : showMsg
    })
  },
  beforeRouteUpdate (to, from, next) {
    let hasFirstPage = to.meta.hasFirstPage

    this.selectTab(to)

    if (hasFirstPage) {
      this.routers = []
    }

    // 判断是否在router列表中
    let routers = this.routers

    let tempRouters = []
    let hasExists = false
    for (let i = 0, length = routers.length; i < length; i++) {
      let router = routers[i]
      let path = router.path

      tempRouters.push(router)
      if (path === to.path) {
        hasExists = true
        this.routers = tempRouters
        break
      }
    }

    if (!hasExists) {
      let router = {
        name: to.name,
        path: to.path
      }

      this.routers.push(router)
    }

    localStorage.routers = JSON.stringify(this.routers)
    this.showMsg = hasFirstPage == null ? false : hasFirstPage

    next(true)
  },
  components: {
    Menus
  },
  created: function () {
    this.routerName = this.$router.currentRoute.name
    this.height = document.body.clientHeight + 'px'

    if (this.loginInfo && this.loginInfo.loginPath === 'channel') {
      let clueSortH5Url = this.loginInfo.clueSortH5Url
      this.msg = '为了更安全的使用本地汽车网，我们的工程师对链接进行了安全加密，请各位渠道朋友看到消息后，立刻更换微信、APP中的汽车网链接，原始链接我们近期将会停止服务。 您的新链接为 ：' + clueSortH5Url
    }

    if (localStorage.userInfo) {
      this.getPermissions()
      this.refreshLoginTime()
    }
  },
  methods: {
    refreshLoginTime: function () {
      let _this = this

      let userInfo = JSON.parse(localStorage.userInfo)

      if (userInfo.loginPath !== 'channel') {
        return
      }

      let params = {
        channelId: userInfo.id
      }

      let listener = {
        success: function (dataInfo) {
          let clueSortH5Url = dataInfo.datas.clueSortH5Url
          _this.loginInfo.clueSortH5Url = clueSortH5Url
          _this.saveLoginInfo(_this.loginInfo)
        }
      }
      channelModel.refreshLoginTime(_this, params, listener)
    },
    onSelect: function (tab) {
      this.$router.push({ path: tab.name })
    },
    handleClick: function (name) {
      let tabs = this.tabs
      let length = tabs.length
      for (var i = 0; i < length; i++) {
        let tab = tabs[i]
        if (tab.path === name) {
          this.tabs.splice(i, 1)
          let newLength = tabs.length
          if (newLength > 0) {
            this.activeName = tabs[newLength - 1].path
          }
          break
        }
      }
    },
    selectTab: function (to) {
      let tabs = this.tabs
      let length = tabs.length
      let index = null
      for (var i = 0; i < length; i++) {
        let tab = this.tabs[i]
        if (tab.path === to.fullPath) {
          index = i
          break
        }
      }

      if (index == null) {
        tabs.push({
          name: to.name,
          path: to.fullPath,
          component: to.matched[to.matched.length - 1].components.default
        })
        this.activeName = to.path
      } else {
        this.activeName = to.path
      }
    },
    onVisibleChanged: function (newVisible) {
      this.xPathDialogVisible = newVisible
    },
    hasDeveloper: function () {
      // 如果当期dialog已经显示了
      if (this.xPathDialogVisible) {
        return false
      }

      if (!localStorage.userInfo) {
        return false
      }

      let userInfo = JSON.parse(localStorage.userInfo)

      if (!localStorage.hasDeveloper || localStorage.hasDeveloper === 'false' || userInfo.role !== 8) {
        return false
      }

      return true
    },
    select: function (position) {
      this.menuGroup = parseInt(position)
    },
    getPermissions () {
      if (!this.loginInfo) {
        return
      }
      let _this = this
      let listener = {
        success: function (dataInfo) {
          let permissions = JSON.stringify(dataInfo.datas)
          localStorage.permissions = permissions
        }
      }
      sysModel.getPermissions(_this, listener)
    },
    loginOut: function () {
      let _this = this
      this.showUserInfo = false
      let listener = {
        success: function () {
          let userInfo = JSON.parse(localStorage.userInfo)
          if (userInfo) {
            if (userInfo.loginPath === 'channel') {
              _this.$router.push('/login/channel')
            } else {
              _this.$router.push('/login/cxh')
            }
          }
          localStorage.clear()
        }
      }
      sysModel.loginOut(_this, listener)
    },
    updatePassword: function (password) {
      let _this = this
      let params = {
        accountId: this.loginInfo.id,
        password: password
      }
      let listener = {
        success: function () {
          _this.$message({
            type: 'success',
            message: '修改密码成功'
          })
          let userInfo = JSON.parse(localStorage.userInfo)
          if (userInfo) {
            if (userInfo.loginPath === 'channel') {
              _this.$router.push('/login/channel')
            } else {
              _this.$router.push('/login/cxh')
            }
          }
          localStorage.clear()
        }
      }
      sysModel.updatePassword(_this, params, listener)
    }
  }
}
</script>
<style>

    .el-aside {
        color: #333;
    }

    .el-main {
        background-color: #faf9f9;
        color: #333;
        padding-top: 0px;
    }
    .el-cascader-menu {
      height: 300px;
    }

</style>
